<template>
  <div>
    <textarea :class="['form-control', 'form-control-text-area', { resize: resizeEnabled, 'is-invalid': hasError() }]"
      ref="inputField"
      v-bind:value="value"
      v-on:input="inputUpdated"
      v-bind:placeholder="placeholder"
      :readonly="readonly"
      :rows="textRowCount"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      @keydown="onTextAreaKeydown"
      />
    <div class="form-invalid-feedback" v-if="hasError()">
      {{getError()}}
    </div>
    <div class="row no-gutters" v-if="(note && !hasError()) || showCharacterCount">
      <div class="col-9">
        <span v-if="!hasError() && note" class="form-field-note">{{note}}</span>
      </div>
      <div class="col-3">
        <span v-if="showCharacterCount" class="form-field-note text-right">{{characterCount}} Characters</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.form-control.form-control-text-area {
  resize: none;
}
.form-control.form-control-text-area.resize {
  resize: vertical;
}
</style>

<script>
import formField from '@/mixins/formField'

export default {
  name: "FormInputTextArea",
  mixins: [formField],
  props: {
    value: String,
    placeholder: String,
    field: String,
    rows: {
      type: Number,
      default: 3
    },
    large: Boolean,
    note: String,
    showCharacterCount: Boolean,
    detectEnterKeypress: Boolean,
    resizeEnabled: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      // Reset error when typing if the field was blank
      // Not 100% fix to clearing errors (eg, some errors may be logic based) but helpful
      if(oldVal == '' || oldVal == null)
        this.resetFieldError(this.$props.field)
        
      // Default to empty string if null given
      if(newVal == null) {
        this.$nextTick(() => {
          this.$emit('input', '')
        })
      }
    }
  },
  computed: {
    textRowCount() {
      if(this.large)
        return 6
      return this.$props.rows
    },
    characterCount() {
      return this.value ? this.value.length : 0
    }
  },
  mounted() {
  },
  methods: {
    hasError() {
      return this.getFieldError(this.$props.field).length > 0
    },
    getError() {
      return this.getFieldError(this.$props.field)
    },
    focus(options = {}) {
      this.$refs.inputField.focus(options)
    },
    select() {
      this.$refs.inputField.select()
    },
    setSelectionRange(selectionStart, selectionEnd) {
      this.$refs.inputField.setSelectionRange(selectionStart, selectionEnd)
    },
    inputUpdated(evt) {
      // Reset error when typing if the field was blank
      // Not 100% fix to clearing errors (eg, some errors may be logic based) but helpful
      if(this.$props.value == '')
        this.resetFieldError(this.$props.field)

      this.$emit('input', evt.target.value)
    },
    onTextAreaKeydown(evt) {
      if (evt.key === 'Enter' && !evt.shiftKey && this.detectEnterKeypress) {
        evt.preventDefault()
        this.$emit('enterPressed')
      }
    },
    insertTextAtCursor(insertText) {
      var startPos = this.$refs.inputField.selectionStart
      var endPos = this.$refs.inputField.selectionEnd
      var cursorPos = startPos
      var curValue = '' + this.value
      
      var updatedContent = curValue.substring(0, startPos) + insertText + curValue.substring(endPos, curValue.length)

      this.$emit('input', updatedContent)

      // Move cursor
      setTimeout(() => {
        cursorPos += insertText.length
        this.$refs.inputField.selectionStart = this.$refs.inputField.selectionEnd = cursorPos
      }, 10)
    }
  }
};
</script>